import _extends from "@babel/runtime/helpers/esm/extends";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["TransitionProps", "backgroundBlur", "backgroundType", "badge", "badgeColor", "badgeLabel", "checkbox", "checkboxText", "checked", "children", "dataAttributes", "destructive", "dialogContentContainerSxProps", "dialogFooterType", "dialogHeaderSupportingText", "dialogHeaderText", "footerCustomNode", "footerDivider", "footerDividerPadding", "fullWidth", "handleClose", "headerDivider", "headerPaddingBottom", "height", "helpIcon", "icon", "iconLeadingColor", "iconLeadingIcon", "iconLeadingSize", "iconLeadingTheme", "maxHeight", "maxWidth", "minHeight", "mobileBreakpoint", "mobileBreakpointContainerRef", "onChangeCheckbox", "onPrimaryButtonClick", "onSecondaryButtonClick", "onTertiaryButtonClick", "open", "padding", "primaryButtonProps", "primaryButtonText", "secondaryButtonProps", "secondaryButtonText", "showCloseButton", "showDialogFooter", "showFeaturedIcon", "tertiaryButton", "tertiaryButtonProps", "tertiaryButtonText", "tooltipDescription", "tooltipLabel", "tooltipPlacement", "tooltipVariant", "type"];
import React, { useEffect, useRef, useState } from 'react';
import { useTheme } from '@mui/material/styles';
import MuiDialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { getBackdropStyles } from '../common/BackgroundOverlayStyles';
import { useConvertToMobile } from '../utils/useConvertToMobile';
import { SHADOWS } from '@im/im-theme/constants';
import { DialogHeader } from '../DialogHeader';
import { DialogFooter } from '../DialogFooter';
import Box from '@mui/material/Box';
import { getScrollbarStyles } from '../common/getScrollbarStyles';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function Dialog(props) {
  var TransitionProps = props.TransitionProps,
    _props$backgroundBlur = props.backgroundBlur,
    backgroundBlur = _props$backgroundBlur === void 0 ? true : _props$backgroundBlur,
    _props$backgroundType = props.backgroundType,
    backgroundType = _props$backgroundType === void 0 ? 'default' : _props$backgroundType,
    badge = props.badge,
    badgeColor = props.badgeColor,
    badgeLabel = props.badgeLabel,
    _props$checkbox = props.checkbox,
    checkbox = _props$checkbox === void 0 ? true : _props$checkbox,
    checkboxText = props.checkboxText,
    _props$checked = props.checked,
    checked = _props$checked === void 0 ? false : _props$checked,
    children = props.children,
    dataAttributes = props.dataAttributes,
    _props$destructive = props.destructive,
    destructive = _props$destructive === void 0 ? false : _props$destructive,
    dialogContentContainerSxProps = props.dialogContentContainerSxProps,
    _props$dialogFooterTy = props.dialogFooterType,
    dialogFooterType = _props$dialogFooterTy === void 0 ? 'horizontal-fill-container' : _props$dialogFooterTy,
    dialogHeaderSupportingText = props.dialogHeaderSupportingText,
    dialogHeaderText = props.dialogHeaderText,
    footerCustomNode = props.footerCustomNode,
    _props$footerDivider = props.footerDivider,
    footerDivider = _props$footerDivider === void 0 ? true : _props$footerDivider,
    footerDividerPadding = props.footerDividerPadding,
    _props$fullWidth = props.fullWidth,
    fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth,
    handleClose = props.handleClose,
    _props$headerDivider = props.headerDivider,
    headerDivider = _props$headerDivider === void 0 ? true : _props$headerDivider,
    _props$headerPaddingB = props.headerPaddingBottom,
    headerPaddingBottom = _props$headerPaddingB === void 0 ? true : _props$headerPaddingB,
    height = props.height,
    helpIcon = props.helpIcon,
    icon = props.icon,
    iconLeadingColor = props.iconLeadingColor,
    iconLeadingIcon = props.iconLeadingIcon,
    iconLeadingSize = props.iconLeadingSize,
    iconLeadingTheme = props.iconLeadingTheme,
    maxHeight = props.maxHeight,
    _props$maxWidth = props.maxWidth,
    maxWidth = _props$maxWidth === void 0 ? false : _props$maxWidth,
    minHeight = props.minHeight,
    mobileBreakpoint = props.mobileBreakpoint,
    mobileBreakpointContainerRef = props.mobileBreakpointContainerRef,
    onChangeCheckbox = props.onChangeCheckbox,
    onPrimaryButtonClick = props.onPrimaryButtonClick,
    onSecondaryButtonClick = props.onSecondaryButtonClick,
    onTertiaryButtonClick = props.onTertiaryButtonClick,
    _props$open = props.open,
    open = _props$open === void 0 ? false : _props$open,
    _props$padding = props.padding,
    padding = _props$padding === void 0 ? true : _props$padding,
    primaryButtonProps = props.primaryButtonProps,
    _props$primaryButtonT = props.primaryButtonText,
    primaryButtonText = _props$primaryButtonT === void 0 ? 'Confirm' : _props$primaryButtonT,
    secondaryButtonProps = props.secondaryButtonProps,
    _props$secondaryButto = props.secondaryButtonText,
    secondaryButtonText = _props$secondaryButto === void 0 ? 'Cancel' : _props$secondaryButto,
    _props$showCloseButto = props.showCloseButton,
    showCloseButton = _props$showCloseButto === void 0 ? true : _props$showCloseButto,
    _props$showDialogFoot = props.showDialogFooter,
    showDialogFooter = _props$showDialogFoot === void 0 ? true : _props$showDialogFoot,
    _props$showFeaturedIc = props.showFeaturedIcon,
    showFeaturedIcon = _props$showFeaturedIc === void 0 ? true : _props$showFeaturedIc,
    _props$tertiaryButton = props.tertiaryButton,
    tertiaryButton = _props$tertiaryButton === void 0 ? true : _props$tertiaryButton,
    tertiaryButtonProps = props.tertiaryButtonProps,
    tertiaryButtonText = props.tertiaryButtonText,
    tooltipDescription = props.tooltipDescription,
    tooltipLabel = props.tooltipLabel,
    tooltipPlacement = props.tooltipPlacement,
    tooltipVariant = props.tooltipVariant,
    _props$type = props.type,
    type = _props$type === void 0 ? 'stack-left-aligned' : _props$type,
    other = _objectWithoutProperties(props, _excluded);
  var dialogHeaderType = props.dialogHeaderType;
  if (!dialogHeaderType) dialogHeaderType = type;
  var theme = useTheme();
  var isMobile = useConvertToMobile(mobileBreakpoint, mobileBreakpointContainerRef);
  var dialogWidth = type === 'horizontal-left-aligned' ? 544 : 400;
  dialogWidth = isMobile ? 343 : dialogWidth;
  var dialogFooterPaddingTop = footerDivider ? 0 : theme.spacing(2);
  var contentRef = useRef(null);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    contentScrollbar = _useState2[0],
    setContentScrollbar = _useState2[1];
  useEffect(function () {
    var handleResize = function handleResize() {
      var _contentRef$current;
      var _ref = (_contentRef$current = contentRef.current) != null ? _contentRef$current : {},
        _ref$offsetWidth = _ref.offsetWidth,
        offsetWidth = _ref$offsetWidth === void 0 ? 0 : _ref$offsetWidth,
        _ref$scrollWidth = _ref.scrollWidth,
        scrollWidth = _ref$scrollWidth === void 0 ? 0 : _ref$scrollWidth;
      setContentScrollbar(offsetWidth !== scrollWidth);
    };
    window.addEventListener('resize', handleResize);
    return function () {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  var paddingLeftRight = isMobile ? 16 : 24;
  var dialogContentPaddingLeft = padding ? paddingLeftRight : 0;
  var dialogContentPaddingRight = contentScrollbar ? 12 : paddingLeftRight;
  dialogContentPaddingRight = padding ? dialogContentPaddingRight : 0;
  return /*#__PURE__*/_jsxs(MuiDialog, _extends({
    BackdropProps: {
      sx: _extends({}, getBackdropStyles(backgroundType, backgroundBlur, theme))
    },
    PaperProps: _extends({}, dataAttributes == null ? void 0 : dataAttributes.dialogPaper),
    TransitionProps: TransitionProps,
    "aria-describedby": "dialog-description",
    "aria-labelledby": "dialog-title",
    fullWidth: fullWidth,
    maxWidth: maxWidth != null ? maxWidth : 'sm',
    onClose: handleClose,
    open: open,
    scroll: "paper",
    sx: {
      '& .MuiDialog-paper': {
        height: height,
        margin: 0,
        maxHeight: maxHeight,
        minHeight: minHeight,
        overflow: 'hidden',
        width: fullWidth ? '100%' : dialogWidth
      },
      borderRadius: '12px',
      boxShadow: theme.shadows[SHADOWS.xl]
    }
  }, other, {
    "data-element": "MuiDialog",
    "data-component": "Dialog",
    "data-source-file": "Dialog.tsx",
    children: [/*#__PURE__*/_jsx(DialogTitle, {
      id: "dialog-title",
      sx: {
        padding: '0px'
      },
      "data-element": "DialogTitle",
      "data-source-file": "Dialog.tsx",
      children: /*#__PURE__*/_jsx(DialogHeader, {
        badge: badge,
        badgeColor: badgeColor,
        badgeDataAttributes: dataAttributes == null ? void 0 : dataAttributes.headerBadgeDialogAttributes,
        badgeLabel: badgeLabel,
        divider: headerDivider,
        helpIcon: helpIcon,
        iconLeadingColor: iconLeadingColor,
        iconLeadingIcon: iconLeadingIcon,
        iconLeadingSize: iconLeadingSize,
        iconLeadingTheme: iconLeadingTheme,
        mobileBreakpoint: mobileBreakpoint,
        onClose: handleClose,
        showCloseButton: showCloseButton,
        showFeaturedIcon: showFeaturedIcon,
        supportingText: dialogHeaderSupportingText,
        text: dialogHeaderText,
        tooltipDescription: tooltipDescription,
        tooltipLabel: tooltipLabel,
        tooltipPlacement: tooltipPlacement,
        tooltipVariant: tooltipVariant,
        type: dialogHeaderType,
        withPaddingBottom: headerPaddingBottom,
        "data-element": "DialogHeader",
        "data-source-file": "Dialog.tsx"
      })
    }), /*#__PURE__*/_jsx(DialogContent, {
      ref: contentRef,
      sx: _extends({}, getScrollbarStyles(theme, theme.palette.common.white), {
        display: 'flex',
        flexDirection: 'column',
        overflowX: 'hidden',
        padding: 0,
        paddingLeft: "".concat(dialogContentPaddingLeft, "px"),
        paddingRight: "".concat(dialogContentPaddingRight, "px")
      }),
      "data-element": "DialogContent",
      "data-source-file": "Dialog.tsx",
      children: /*#__PURE__*/_jsx(Box, {
        sx: _extends({
          display: 'flex',
          flexDirection: 'column',
          flexGrow: 1
        }, dialogContentContainerSxProps, {
          width: fullWidth ? '100%' : dialogWidth - dialogContentPaddingLeft - dialogContentPaddingRight
        }),
        "data-element": "Box",
        "data-source-file": "Dialog.tsx",
        children: children
      })
    }), showDialogFooter && /*#__PURE__*/_jsx(DialogFooter, {
      checkbox: checkbox,
      checkboxText: checkboxText,
      checked: checked,
      customNode: footerCustomNode,
      destructive: destructive,
      divider: footerDivider,
      dividerPadding: footerDividerPadding,
      icon: icon,
      isMobile: isMobile,
      onChangeCheckbox: onChangeCheckbox,
      onPrimaryButtonClick: onPrimaryButtonClick,
      onSecondaryButtonClick: onSecondaryButtonClick,
      onTertiaryButtonClick: onTertiaryButtonClick,
      primaryButtonProps: primaryButtonProps,
      primaryButtonText: primaryButtonText,
      secondaryButtonProps: secondaryButtonProps,
      secondaryButtonText: secondaryButtonText,
      sx: {
        paddingTop: isMobile ? 0 : dialogFooterPaddingTop
      },
      tertiaryButton: tertiaryButton,
      tertiaryButtonProps: tertiaryButtonProps,
      tertiaryButtonText: tertiaryButtonText,
      type: dialogFooterType
    })]
  }));
}